import { isAxiosError } from 'axios'

const DEFAULT_ERROR_MESSAGE = 'تعذر إتمام العملية. يرجى المحاولة مرة أخرى.'
export const EMAIL_ALREADY_IN_USE_MESSAGE =
  'البريد الإلكتروني مستخدم بالفعل. يرجى استخدام بريد إلكتروني آخر.'

const exactTranslations: Record<string, string> = {
  'access denied': 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  'authentication required': 'يرجى تسجيل الدخول للمتابعة.',
  'bad request': 'البيانات المدخلة غير صحيحة. يرجى مراجعتها والمحاولة مرة أخرى.',
  'connection refused': 'تعذر الاتصال بالخادم. يرجى المحاولة لاحقاً.',
  'email is already in use': EMAIL_ALREADY_IN_USE_MESSAGE,
  'failed to fetch': 'تعذر الاتصال بالخادم. يرجى التحقق من اتصال الإنترنت والمحاولة مرة أخرى.',
  'field required': 'هذا الحقل مطلوب.',
  forbidden: 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  'group day is assigned to a session':
    'لا يمكن حذف مجموعة الأيام لأنها مرتبطة بحلقة. غيّر مجموعة الأيام في الحلقة أولاً.',
  'internal server error': 'حدث خطأ في الخادم. يرجى المحاولة لاحقاً.',
  'invalid credentials': 'بيانات تسجيل الدخول غير صحيحة.',
  'network error': 'تعذر الاتصال بالخادم. يرجى التحقق من اتصال الإنترنت والمحاولة مرة أخرى.',
  'not found': 'لم يتم العثور على البيانات المطلوبة.',
  'odoo session expired': 'انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  'request timeout': 'استغرق الطلب وقتاً طويلاً. يرجى المحاولة مرة أخرى.',
  'session expired': 'انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.',
  'timeout of 0ms exceeded': 'استغرق الطلب وقتاً طويلاً. يرجى المحاولة مرة أخرى.',
  unauthorized: 'يرجى تسجيل الدخول للمتابعة.',
  'validation error': 'يرجى مراجعة البيانات المدخلة.',
  'wrong login/password': 'بيانات تسجيل الدخول غير صحيحة.'
}

const statusTranslations: Record<number, string> = {
  400: 'البيانات المدخلة غير صحيحة. يرجى مراجعتها والمحاولة مرة أخرى.',
  401: 'انتهت صلاحية الجلسة أو لم يتم تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.',
  403: 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  404: 'لم يتم العثور على البيانات المطلوبة.',
  408: 'استغرق الطلب وقتاً طويلاً. يرجى المحاولة مرة أخرى.',
  409: 'تعذر تنفيذ الإجراء بسبب تعارض في البيانات. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
  422: 'يرجى مراجعة البيانات المدخلة.',
  429: 'تم إرسال طلبات كثيرة. يرجى الانتظار قليلاً ثم المحاولة مرة أخرى.',
  500: 'حدث خطأ في الخادم. يرجى المحاولة لاحقاً.',
  502: 'الخدمة غير متاحة مؤقتاً. يرجى المحاولة لاحقاً.',
  503: 'الخدمة غير متاحة مؤقتاً. يرجى المحاولة لاحقاً.',
  504: 'استغرق الخادم وقتاً طويلاً للاستجابة. يرجى المحاولة لاحقاً.'
}

const validationTranslations: Array<[RegExp, string]> = [
  [/field required/i, 'هذا الحقل مطلوب.'],
  [/not a valid email|valid email address|invalid email/i, 'يرجى إدخال بريد إلكتروني صحيح.'],
  [/this field cannot be null/i, 'هذا الحقل مطلوب.']
]

const studentFieldLabels: Record<string, string> = {
  first_name: 'الاسم الأول',
  firstName: 'الاسم الأول',
  middle_name: 'اسم الأب',
  middleName: 'اسم الأب',
  last_name: 'اسم العائلة',
  lastName: 'اسم العائلة',
  gender: 'الجنس',
  mobile: 'رقم الجوال',
  email: 'البريد الإلكتروني',
  date_of_birth: 'تاريخ الميلاد',
  dateOfBirth: 'تاريخ الميلاد',
  quranic_narratives_id: 'الرواية المطلوبة',
  quranicNarrativeId: 'الرواية المطلوبة',
  quranic_level: 'المستوى القرآني',
  quranicLevelId: 'المستوى القرآني',
  number_of_parts_saved: 'عدد الأجزاء المحفوظة',
  numberOfPartsSaved: 'عدد الأجزاء المحفوظة',
  group_day_id: 'أيام التسميع',
  groupDayId: 'أيام التسميع',
  recitation_time: 'وقت التسميع',
  recitation_time_id: 'وقت التسميع',
  recitationTimeId: 'وقت التسميع',
  arabic_speaking_level: 'مستوى التحدث بالعربية',
  arabicSpeakingLevel: 'مستوى التحدث بالعربية',
  tmp_password: 'كلمة المرور',
  password: 'كلمة المرور',
  student_session_id: 'الحلقة',
  session_id: 'الحلقة',
  sessionId: 'الحلقة',
  session: 'الحلقة',
  date_start_plan: 'تاريخ بداية الخطة',
  date_end_plan: 'تاريخ نهاية الخطة',
  daily_recitation_plan_id: 'خطة الحفظ اليومية',
  recitation_start_id: 'بداية الحفظ',
  daily_revision_plan_id: 'خطة المراجعة اليومية',
  revision_start_id: 'بداية المراجعة',
  plan_template: 'قالب الخطة',
  'plan template': 'قالب الخطة',
  plan_start_line: 'بداية الخطة',
  'plan start line': 'بداية الخطة',
  'group day': 'أيام التسميع',
  'Quranic narrative': 'الرواية المطلوبة',
  'Quranic level': 'المستوى القرآني',
  'recitation time': 'وقت التسميع'
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^$()|[\]{}\\]/g, '\\$&')
}

function getValidationFieldLabels(message: string) {
  const labels = Object.entries(studentFieldLabels)
    .filter(([field]) => {
      const pattern = new RegExp('(^|[^a-z0-9_])' + escapeRegExp(field) + '(?=$|[^a-z0-9_])', 'i')
      return pattern.test(message)
    })
    .map(([, label]) => label)

  return [...new Set(labels)]
}

function formatFieldLabels(labels: string[]) {
  if (labels.length === 1) return '«' + labels[0] + '»'
  return labels.map((label) => '«' + label + '»').join('، ')
}

function translateValidationMessage(message: string): string | undefined {
  const labels = getValidationFieldLabels(message)
  const fields = formatFieldLabels(labels)

  if (/not a valid email|valid email address|invalid email/i.test(message)) {
    return 'يرجى إدخال بريد إلكتروني صحيح.'
  }

  if (/required|cannot be null/i.test(message)) {
    return labels.length
      ? 'يرجى تعبئة ' + (labels.length === 1 ? 'حقل' : 'الحقول') + ' ' + fields + '.'
      : 'هذا الحقل مطلوب.'
  }

  if (/positive integer id|positive integer|must reference|invalid .*reference/i.test(message)) {
    return labels.length
      ? 'يرجى اختيار قيمة صالحة لحقل ' + fields + '.'
      : 'يرجى اختيار قيمة صحيحة من القائمة.'
  }

  if (/must be a date|valid date|rfc3339|date.*invalid|invalid date/i.test(message)) {
    return labels.length ? 'يرجى إدخال تاريخ صحيح لحقل ' + fields + '.' : 'يرجى إدخال تاريخ صحيح.'
  }

  if (/gender must be male or female/i.test(message)) {
    return 'يرجى اختيار الجنس: ذكر أو أنثى.'
  }

  if (/arabic.?speaking.?level.*invalid/i.test(message)) {
    return 'يرجى اختيار مستوى التحدث بالعربية من القائمة.'
  }

  if (/cannot be negative|must be greater than or equal to/i.test(message)) {
    return labels.length
      ? 'يجب أن تكون القيمة في حقل ' + fields + ' صفراً أو أكبر.'
      : 'يجب أن تكون القيمة صفراً أو أكبر.'
  }

  const minimum = message.match(/must be at least (\d+) characters?/i)
  if (minimum) {
    return labels.length
      ? 'يجب ألا تقل قيمة حقل ' + fields + ' عن ' + minimum[1] + ' أحرف.'
      : 'القيمة المدخلة أقصر من الحد الأدنى المسموح به.'
  }

  const maximum = message.match(/must be at most (\d+) characters?/i)
  if (maximum) {
    return labels.length
      ? 'يجب ألا تزيد قيمة حقل ' + fields + ' عن ' + maximum[1] + ' أحرف.'
      : 'القيمة المدخلة أطول من الحد الأقصى المسموح به.'
  }

  if (/value is not a valid|\binvalid\b/i.test(message)) {
    return labels.length
      ? 'القيمة المدخلة في حقل ' + fields + ' غير صحيحة.'
      : 'يرجى مراجعة البيانات المدخلة.'
  }
}

const entityLabels: Record<string, string> = {
  'group day': 'مجموعة الأيام',
  session: 'حلقة',
  student: 'طالب',
  teacher: 'معلم',
  administrator: 'مشرف',
  'plan template': 'قالب الخطة',
  'quranic narrative': 'الرواية القرآنية'
}

function translateDependencyMessage(message: string): string | undefined {
  const assignedMatch = message.match(/^(.+?) is assigned to (?:a |an )?(.+?)$/i)
  if (!assignedMatch) return undefined

  const source = entityLabels[assignedMatch[1].toLowerCase()]
  const target = entityLabels[assignedMatch[2].toLowerCase()]
  if (!source || !target) return undefined

  return `لا يمكن حذف ${source} لأنها مرتبطة بـ${target}. أزل الارتباط أولاً ثم حاول مرة أخرى.`
}

function hasArabicText(value: string) {
  return /[\u0600-\u06FF]/.test(value)
}

function cleanMessage(value: string) {
  return value.replace(/\s+/g, ' ').trim()
}

function translateString(value: string, fallback: string) {
  const message = cleanMessage(value)

  if (!message) return fallback
  if (/^error:\s*/i.test(message))
    return translateString(message.replace(/^error:\s*/i, ''), fallback)

  if (hasArabicText(message)) {
    // Older pages prepend their own generic Arabic copy to `error.message`.
    // When the server message is already Arabic, keep that useful detail rather
    // than reducing it back to the generic prefix.
    const prefixedServerMessage = message.match(
      /^(?:حدث خطأ(?:[^:]*?)?|تعذر(?:[^:]*?)?)\s*:\s*(.+)$/
    )?.[1]
    if (prefixedServerMessage && hasArabicText(prefixedServerMessage)) {
      return prefixedServerMessage.trim()
    }

    // Several legacy call sites add an Arabic prefix to a raw server message
    // (for example: "حدث خطأ: Network Error"). Keep the useful Arabic context
    // but never expose the technical English suffix to the user.
    const withoutTechnicalSuffix = message
      .replace(/\s*[:\-–—]\s*[a-z][\s\S]*$/i, '')
      .replace(/\s*\([a-z][^)]*\)\s*$/i, '')
      .trim()

    return withoutTechnicalSuffix || fallback
  }

  const normalized = message.toLowerCase()
  if (exactTranslations[normalized]) return exactTranslations[normalized]

  const validationMessage = translateValidationMessage(message)
  if (validationMessage) return validationMessage

  const dependencyMessage = translateDependencyMessage(message)
  if (dependencyMessage) return dependencyMessage

  for (const [pattern, translation] of validationTranslations) {
    if (pattern.test(message)) return translation
  }

  if (/^request failed with status code \d+$/i.test(message)) return fallback

  return fallback
}

function getPayloadMessage(payload: unknown): unknown {
  if (!payload || typeof payload !== 'object') return payload

  const data = payload as Record<string, unknown>
  const nestedError = data.error

  if (typeof nestedError === 'object' && nestedError !== null) {
    const error = nestedError as Record<string, unknown>
    const errorData = error.data as Record<string, unknown> | undefined
    return (
      errorData?.message ??
      errorData?.detail ??
      error.message ??
      error.detail ??
      error.title ??
      error.msg ??
      nestedError
    )
  }

  // JSON-RPC services return a successful HTTP response with their business
  // error in `error.data.message`. The Axios interceptor can already have
  // replaced the top-level message with a generic Arabic fallback, so retain
  // this original detailed message as the source for the central translator.
  const errorData = data.data
  if (typeof errorData === 'object' && errorData !== null) {
    const details = errorData as Record<string, unknown>
    const detailedMessage =
      details.message ?? details.detail ?? details.title ?? details.msg ?? details.errors
    if (detailedMessage !== undefined) return detailedMessage
  }

  return data.message ?? data.detail ?? data.title ?? data.msg ?? data.errors ?? nestedError
}

function translateValidationDetails(details: unknown, fallback: string): string {
  if (Array.isArray(details)) {
    const messages = details
      .map((detail) => getUserFriendlyErrorMessage(detail, ''))
      .filter(Boolean)

    return messages.length ? [...new Set(messages)].join(' ') : fallback
  }

  if (details && typeof details === 'object') {
    const messages = Object.entries(details as Record<string, unknown>)
      .flatMap(([field, value]) =>
        (Array.isArray(value) ? value : [value]).map((item) => [field, item])
      )
      .map(([field, value]) =>
        getUserFriendlyErrorMessage(typeof value === 'string' ? field + ' ' + value : value, '')
      )
      .filter(Boolean)

    return messages.length ? [...new Set(messages)].join(' ') : fallback
  }

  return fallback
}

/**
 * Converts API, validation, and runtime errors into a safe Arabic message for users.
 * Raw server text is only retained when it is already Arabic; technical English text
 * intentionally falls back to a friendly explanation.
 */
export function getUserFriendlyErrorMessage(
  error: unknown,
  fallback = DEFAULT_ERROR_MESSAGE
): string {
  if (isAxiosError(error)) {
    const payload = error.response?.data
    const statusFallback = statusTranslations[error.response?.status ?? 0] ?? fallback
    const payloadMessage = getPayloadMessage(payload)

    if (Array.isArray(payloadMessage) || (payloadMessage && typeof payloadMessage === 'object')) {
      return translateValidationDetails(payloadMessage, statusFallback)
    }

    if (typeof payloadMessage === 'string') {
      return translateString(payloadMessage, statusFallback)
    }

    if (error.code === 'ERR_NETWORK') return exactTranslations['network error']
    if (error.code === 'ECONNABORTED') return exactTranslations['request timeout']

    return translateString(error.message, statusFallback)
  }

  if (Array.isArray(error)) {
    return translateValidationDetails(error, fallback)
  }

  if (error && typeof error === 'object' && !(error instanceof Error)) {
    const payloadMessage = getPayloadMessage(error)
    if (payloadMessage !== error) return getUserFriendlyErrorMessage(payloadMessage, fallback)

    return translateValidationDetails(error, fallback)
  }

  if (error instanceof Error) return translateString(error.message, fallback)
  if (typeof error === 'string') return translateString(error, fallback)

  return fallback
}

export function getEmailAlreadyInUseMessage(error: unknown): string | undefined {
  const message = getUserFriendlyErrorMessage(error, '')

  if (
    message === EMAIL_ALREADY_IN_USE_MESSAGE ||
    /email.*(?:already|assigned|duplicate|exists|in use)|البريد الإلكتروني.*مستخدم/i.test(message)
  ) {
    return EMAIL_ALREADY_IN_USE_MESSAGE
  }
}

export function toUserFriendlyError(error: unknown, fallback?: string) {
  return new Error(getUserFriendlyErrorMessage(error, fallback))
}
